<template>
    <div
        :id="id"
        :class="classString"
    >
        <h3 class="lni-u-heading--3">
            {{ heading }}
        </h3>
        <div class="lni-u-flex lni-u-flex-wrap">
            <div class="lni-u-mvauto --width30">
                {{ content?.discomfortExtremity }}
            </div>
            <lni-select
                :id="`${id}_lower-extremity`"
                :options="options"
                labelText=" "
                :customWidth="5"
                :dense="true"
                :changeAction="`${id}/updateState`"
                @change="onChange"
            />
        </div>
        <div class="lni-u-flex lni-u-flex-wrap">
            <div class="lni-u-mvauto --width30">
                {{ content?.discomfortOverall }}
            </div>
            <lni-select
                :id="`${id}_overall`"
                :options="options"
                labelText=" "
                :customWidth="5"
                :dense="true"
                :changeAction="`${id}/updateState`"
                @change="onChange"
            />
        </div>
        <div class="lni-u-flex lni-u-flex-wrap">
            <div class="lni-u-mvauto --width30">
                {{ content?.discomfortHandWrist }}
            </div>
            <lni-select
                :id="`${id}_hand-wrist`"
                :options="options"
                labelText=" "
                :customWidth="5"
                :dense="true"
                :changeAction="`${id}/updateState`"
                @change="onChange"
            />
        </div>
        <div class="lni-u-flex lni-u-flex-wrap">
            <div class="lni-u-mvauto --width30">
                {{ content?.discomfortShoulder }}
            </div>
            <lni-select
                :id="`${id}_shoulder`"
                :options="options"
                labelText=" "
                :customWidth="5"
                :dense="true"
                :changeAction="`${id}/updateState`"
                @change="onChange"
            />
        </div>
        <div class="lni-u-flex lni-u-flex-wrap">
            <div class="lni-u-mvauto --width30">
                {{ content?.discomfortBack }}
            </div>
            <lni-select
                :id="`${id}_lower-back`"
                :options="options"
                labelText=" "
                :customWidth="5"
                :dense="true"
                :changeAction="`${id}/updateState`"
                @change="onChange"
            />
        </div>
    </div>
</template>

<script>
import {
    mapGetters,
} from 'vuex';

export default {
    name: 'LniJanitorialShiftDiscomfort',
    emits: ['change'],
    computed: {
        options() {
            const result = [];
            for (let i = 0; i <= 10; i++) {
                result.push({
                    text: `${i}`,
                    value: `${i}`,
                });
            }

            return result;
        },
        ...mapGetters({
            content: 'appState/content',
        }),
    },
    methods: {
        onChange() {
            const storeState = this.$store.state[this.id];
            this.$emit('change', {
                overall: storeState.overall.length ? Number(storeState.overall) : -1,
                lowerExtremity: storeState.lowerExtremity.length ? Number(storeState.lowerExtremity) : -1,
                handWrist: storeState.handWrist.length ? Number(storeState.handWrist) : -1,
                shoulder: storeState.shoulder.length ? Number(storeState.shoulder) : -1,
                lowerBack: storeState.lowerBack.length ? Number(storeState.lowerBack) : -1,
            });
        },
    },
};
</script>